import { useContext } from "react";

import { Button } from "@jti/core-components/components/Button";
import { FormattedPrice } from "@jti/ui/components/FormattedPrice";

import { PriceTiersContext } from "@product-details/providers/PriceTiersContext";

import styles from "./AddProductButton.module.scss";

export type AddToCartButtonProps = {
  onClick: () => void;
  isLoading: boolean;
  isDisabled?: boolean;
  testId: string;
  label: string;
};

const AddToCartButton = ({ isLoading, onClick, testId, label, isDisabled }: AddToCartButtonProps) => {
  const { selectedPriceTier } = useContext(PriceTiersContext);
  const hasPrice = selectedPriceTier && selectedPriceTier.quantity > 1;
  const formattedPrice = selectedPriceTier?.total_price && <FormattedPrice {...selectedPriceTier.total_price} />;

  return (
    <div className={styles.addProductButtonWrapper}>
      <Button
        pending={isLoading}
        onClick={onClick}
        data-testid={testId}
        className={styles.button}
        data-event-selector="product-details-add-product-button"
        disabled={isDisabled}
        richContent={
          <>
            {label} {hasPrice && <>({formattedPrice})</>}
          </>
        }
      />
    </div>
  );
};

export default AddToCartButton;
